<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4784_26382)">
      <rect x="4" width="22" height="22" rx="11" fill="white" />
    </g>
    <path
      d="M15 22C8.92491 22 4 17.0751 4 11C4 4.92491 8.92491 0 15 0C21.0751 0 26 4.92491 26 11C26 17.0751 21.0751 22 15 22ZM15.0038 4.8125C12.3456 4.8125 10.1875 7.01147 10.1875 9.72812C10.1875 12.5586 13.5707 15.8235 14.6652 16.8111C14.858 16.9892 15.143 16.9892 15.3355 16.8111C16.4293 15.8242 19.8125 12.5589 19.8125 9.72847C19.8208 7.01078 17.663 4.8125 15.0038 4.8125ZM15.2135 15.6461C15.1546 15.7012 15.0769 15.7319 14.9962 15.7319C14.9155 15.7319 14.8379 15.7012 14.779 15.6461C13.9423 14.8617 10.9898 11.9175 10.9898 9.58581C10.9898 7.39131 12.7818 5.62134 15.0003 5.62134C17.2107 5.62134 19.0102 7.39956 19.0102 9.58478C19.0019 11.9175 16.0416 14.8541 15.2131 15.6451L15.2135 15.6461ZM15 7.23903C13.6738 7.23903 12.5938 8.32116 12.5938 9.66522C12.5938 11.0017 13.6738 12.0921 15 12.0921C16.3262 12.0921 17.4062 11.0096 17.4062 9.66522C17.4062 8.32116 16.3262 7.23903 15 7.23903ZM15 11.2829C14.5719 11.2808 14.1621 11.109 13.8605 10.8051C13.7117 10.655 13.5941 10.477 13.5144 10.2814C13.4347 10.0857 13.3945 9.87616 13.3961 9.66488C13.3953 9.23654 13.5639 8.82528 13.8653 8.52087C14.0137 8.37089 14.1905 8.25185 14.3852 8.17066C14.58 8.08947 14.789 8.04773 15 8.04788C15.211 8.04773 15.42 8.08947 15.6148 8.17066C15.8095 8.25185 15.9863 8.37089 16.1347 8.52087C16.4361 8.82528 16.6047 9.23654 16.6039 9.66488C16.6056 9.8761 16.5655 10.0856 16.4858 10.2812C16.4062 10.4768 16.2886 10.6548 16.1399 10.8047C15.8381 11.1086 15.4282 11.2807 15 11.2829Z"
      fill="#189FED"
    />
    <defs>
      <filter
        id="filter0_d_4784_26382"
        x="0"
        y="0"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4784_26382"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4784_26382"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CurrentDevice',
} as DefineComponent
</script>
